/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { ConfigurationKey } from "./ConfigurationKey";
import * as t from "io-ts";

// required attributes
const ConfigurationKeysR = t.interface({
  configuration_keys: t.readonlyArray(
    ConfigurationKey,
    "array of ConfigurationKey"
  )
});

// optional attributes
const ConfigurationKeysO = t.partial({});

export const ConfigurationKeys = t.intersection(
  [ConfigurationKeysR, ConfigurationKeysO],
  "ConfigurationKeys"
);

export type ConfigurationKeys = t.TypeOf<typeof ConfigurationKeys>;
